const FAVORITE_FORM_SELECTOR = "[data-favorite-form]";

export function initFavoriteForms(root = document) {
    root.querySelectorAll(FAVORITE_FORM_SELECTOR).forEach((form) => {
        if (form.dataset.favoriteInitialized === "true") return;

        form.dataset.favoriteInitialized = "true";
        form.addEventListener("submit", toggleFavorite);
    });
}

async function toggleFavorite(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const button = form.querySelector('button[type="submit"]');
    const csrfToken = form.querySelector('input[name="_token"]')?.value;

    if (!button) return;

    const wasDisabled = button.disabled;
    setError(form);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    try {
        const headers = new Headers({
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
        });

        if (csrfToken) headers.set("X-CSRF-TOKEN", csrfToken);

        const response = await fetch(form.action, {
            method: "POST",
            headers,
            body: new URLSearchParams(new FormData(form)),
            credentials: "same-origin",
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || typeof data.is_favorite !== "boolean") {
            throw new Error(data.message || "Favoriet opslaan mislukt.");
        }

        updateFavoriteButton(form, button, data.is_favorite);
        form.dispatchEvent(
            new CustomEvent("favorite:toggled", {
                bubbles: true,
                detail: { isFavorite: data.is_favorite },
            })
        );
    } catch (error) {
        console.error("Favoriet opslaan mislukt.", error);
        setError(form, "Opslaan mislukt. Probeer het opnieuw.");
    } finally {
        button.disabled = wasDisabled;
        button.removeAttribute("aria-busy");
    }
}

function updateFavoriteButton(form, button, isFavorite) {
    const activeClass = form.dataset.favoriteActiveClass || "";
    const inactiveClass = form.dataset.favoriteInactiveClass || "";

    replaceClasses(
        button,
        `${activeClass} ${inactiveClass}`,
        isFavorite ? activeClass : inactiveClass
    );

    const icon = button.querySelector("[data-favorite-icon]");
    const activeIcon = form.dataset.favoriteActiveIcon || "";
    const inactiveIcon = form.dataset.favoriteInactiveIcon || "";

    replaceClasses(
        icon,
        `${activeIcon} ${inactiveIcon}`,
        isFavorite ? activeIcon : inactiveIcon
    );

    button.setAttribute("aria-pressed", String(isFavorite));
}

function replaceClasses(element, classesToRemove, classesToAdd) {
    if (!element) return;

    const remove = splitClasses(classesToRemove);
    const add = splitClasses(classesToAdd);

    if (remove.length) element.classList.remove(...remove);
    if (add.length) element.classList.add(...add);
}

function splitClasses(classNames = "") {
    return classNames.split(/\s+/).filter(Boolean);
}

function setError(form, message = "") {
    const error = form.querySelector("[data-favorite-error]");
    if (!error) return;

    error.textContent = message;
    error.hidden = message === "";
}
